import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

const EnvironmentBooleanSchema = z.preprocess(Boolean, z.boolean().default(false))

const runtimeEnvironment =
  globalThis.window.appConfig?.ENABLED?.toLowerCase() === "true" ? globalThis.window.appConfig : import.meta.env;

export const environment = createEnv({
  clientPrefix: "VITE_",
  client: {
    VITE_API_URL: z.url(),
    VITE_ENABLE_TANSTACK_QUERY_DEVTOOLS: EnvironmentBooleanSchema,
    VITE_ENABLE_TANSTACK_ROUTER_DEVTOOLS: EnvironmentBooleanSchema,
  },
  runtimeEnv: runtimeEnvironment as Record<string, string | boolean | undefined>,
  emptyStringAsUndefined: true,
});

export function isDevelopment() {
  return import.meta.env.DEV;
}

